<template>
  <div>
    <svg
      height="35px"
      width="35px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512.001 512.001"
      xml:space="preserve"
    >
      <path
        style="fill: #bec8d6"
        d="M80.897,495.43c-20.726,0-41.45-7.889-57.229-23.667c-31.557-31.557-31.557-82.902,0-114.458
	L333.82,47.15c19.719-19.719,45.937-30.579,73.825-30.579s54.105,10.86,73.825,30.579c40.707,40.707,40.707,106.943,0,147.65
	L258.657,417.613c-4.79,4.79-12.557,4.79-17.348,0c-4.791-4.79-4.79-12.557,0-17.348l222.813-222.813
	c31.142-31.142,31.142-81.814,0-112.956c-15.086-15.086-35.143-23.394-56.477-23.394c-21.334,0-41.393,8.308-56.479,23.394
	L41.014,374.651c-10.653,10.653-16.52,24.816-16.52,39.883s5.867,29.23,16.52,39.883c21.992,21.992,57.774,21.99,79.765,0
	l244.27-244.27c12.817-12.818,12.817-33.672,0-46.488c-12.815-12.817-33.671-12.817-46.487,0l-156.93,156.929
	c-4.789,4.79-12.557,4.79-17.346,0c-4.79-4.79-4.79-12.557,0-17.348l156.93-156.929c22.382-22.382,58.8-22.382,81.182,0
	c22.382,22.383,22.382,58.8,0,81.182l-244.274,244.27C122.347,487.54,101.622,495.43,80.897,495.43z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "ClipImg"
};
</script>
